import React from 'react';
import { motion } from 'framer-motion';
import { Plus, Database } from 'lucide-react';

interface DNSRecordListEmptyProps {
  onAddRecord: () => void;
}

const DNSRecordListEmpty: React.FC<DNSRecordListEmptyProps> = ({ onAddRecord }) => {
  return (
    <motion.div
      className="text-center py-8"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <div className="w-12 h-12 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mx-auto mb-3">
        <Database className="w-6 h-6 text-slate-400" />
      </div>
      <p className="text-body-small text-slate-500 dark:text-slate-400">
        No DNS records found
      </p>
      <p className="text-body-small text-slate-400 dark:text-slate-500 mt-1">
        Click "Add Record" to create your first DNS record
      </p>
      <motion.button
        className="inline-flex items-center justify-center px-4 py-2 text-white bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 font-medium rounded-lg transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed mt-4 text-sm"
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={onAddRecord}
      >
        <Plus className="w-4 h-4 mr-2" />
        Add Your First Record
      </motion.button>
    </motion.div>
  );
};

export default DNSRecordListEmpty;